import * as api from "../Api";

export const approvedUndefinedInvestments = () => async (dispatch) => {
  try {
    const { data } = await api.getApprovedUndefinedInvestments();
    dispatch({ type: "GET_UNDEFINED_APPROVED_INVESTMENTS", payload: data });
  } catch (error) {}
};
